import React, { useEffect, useState } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { contactAtom, contactInstrumentDecisionStepAtom } from 'pages/Contacts/atoms/contactAtoms'
import { Contact, ContactInstrumentDecisionStep } from 'types/contacts'
import { ContactDecision } from './ContactDecision'
import { ContactForm } from './ContactForm'
import { ContactInstrumentForm } from './ContactInstrumentForm'

export const ContactInstrumentDecision = () => {
  const { t } = useTranslation()
  const [isExistingContact, setIsExistingContact] = useState(false)
  const [action, setAction] = useAtom(actionAtom)
  const step = useAtomValue(contactInstrumentDecisionStepAtom)
  const [contactHandleStep, setContactHandleStep] = useAtom(contactInstrumentDecisionStepAtom)
  const setContact = useSetAtom(contactAtom)

  const showBack =
    contactHandleStep !== ContactInstrumentDecisionStep.CONTACT_DECISION &&
    !(contactHandleStep === ContactInstrumentDecisionStep.INSTRUMENT && !isExistingContact)

  const getSheetHeader = (): string => {
    switch (contactHandleStep) {
      case ContactInstrumentDecisionStep.CONTACT:
        return t('contacts.addCryptoContact')
      case ContactInstrumentDecisionStep.CONTACT_DECISION:
        return t('contacts.existingContact')
      case ContactInstrumentDecisionStep.INSTRUMENT:
        return t('contacts.addCryptoAccount')
      default:
        return ''
    }
  }

  const handleContactSelect = (contact: Contact) => {
    setContact(contact)
    setIsExistingContact(true)
    setContactHandleStep(ContactInstrumentDecisionStep.INSTRUMENT)
  }

  const handleOnBack = () => {
    if (contactHandleStep === ContactInstrumentDecisionStep.CONTACT) {
      setContactHandleStep(ContactInstrumentDecisionStep.CONTACT_DECISION)
    }
    if (contactHandleStep === ContactInstrumentDecisionStep.INSTRUMENT) {
      setIsExistingContact(false)
      setContactHandleStep(ContactInstrumentDecisionStep.CONTACT_DECISION)
    }
    setContact(null)
  }

  useEffect(() => {
    setAction({
      ...action,
      header: getSheetHeader(),
      onClose: () => {
        action?.onClose()
        setContactHandleStep(ContactInstrumentDecisionStep.CONTACT_DECISION)
      },
      onBack: showBack ? handleOnBack : null,
      meta: {
        ...action?.meta,
        handleContactSelect,
      },
    })
  }, [contactHandleStep])

  return (
    <Box width="full">
      {step === ContactInstrumentDecisionStep.CONTACT_DECISION && (
        <ContactDecision setIsExistingContact={setIsExistingContact} />
      )}
      {step === ContactInstrumentDecisionStep.CONTACT && <ContactForm />}
      {step === ContactInstrumentDecisionStep.INSTRUMENT && <ContactInstrumentForm />}
    </Box>
  )
}
